export function shuffle<T>(lst: Readonly<T[]>) {
  const idx = Math.floor(lst.length * Math.random())
  // const idx = secureRandomNumber(0, lst.length)
  return lst[idx]
}
